const CCO = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(1e3 28)"
      d="m0 0h53l40 2 37 3 48 6 40 7 41 9 39 10 39 12 29 10 34 13 28 12 26 12 46 23 21 12 27 16 22 14 15 10 17 12 14 10 21 16 10 8 14 11 15 13 14 12 13 12 5 4v2l4 2 40 40 7 8 14 15 9 11 10 11 11 14 13 16 15 20 10 14 14 20 12 19 14 22 16 28 10 18 15 29 11 23 15 34 13 33 12 34 11 35 10 37 9 38 8 43 6 42 4 40 2 30 1 30v42l-2 50-4 44-5 36-6 37-9 42-8 32-13 44-14 41-13 33-14 32-14 30-10 19-8 16-16 28-10 17-11 17-14 22-13 18-12 17-10 13-12 15-11 14-9 10-9 11-11 12-7 8-9 9-7 8-30 30-8 7-8 8-11 9-12 11-11 9-13 11-12 9-14 11-18 13-20 14-23 15-19 12-26 15-16 9-42 22-33 15-28 12-29 11-34 12-33 10-34 9-29 7-47 9-40 6-49 5-32 2-24 1h-48l-41-2-37-3-33-4-39-6-31-6-43-10-36-10-35-11-31-11-28-11-36-16-26-12-29-15-20-11-24-14-18-11-20-13-12-8-18-13-14-10-13-10-14-11-10-8-14-12-11-9-12-11-8-7-15-15-8-7-19-19-7-8-12-12-9-11-12-13-9-11-14-17-10-13-16-21-11-16-14-20-11-18-11-17-15-26-10-18-15-29-15-31-13-30-14-36-8-23-11-33-11-40-9-38-8-41-6-40-4-35-3-40-1-21v-71l3-49 4-39 7-47 8-41 10-42 12-42 12-36 11-30 14-34 9-20 12-25 12-24 12-22 14-24 12-20 24-36 12-17 14-19 22-28 12-14 9-11 12-13 7-8 7-7 7-8 36-36 8-7 7-7 11-9 12-11 11-9 15-12 14-11 20-15 20-14 13-9 25-16 21-13 25-14 10-6 54-27 32-14 30-12 36-13 41-13 37-10 35-8 49-9 44-6 31-3 31-2z"
      fill="#E8B334"
    />
    <path
      transform="translate(1914,596)"
      d="m0 0h3l4 12 4 7 2 1 2 4-1-4-1-7 2-1 1-2v3h3l15 34 13 33 12 34 11 35 10 37 9 38 8 43 6 42 4 40 2 30 1 30v42l-2 50-4 44-5 36-6 37-9 42-8 32-13 44-14 41-13 33-14 32-14 30-10 19-8 16-16 28-10 17-11 17-14 22-13 18-12 17-10 13-12 15-11 14-9 10-9 11-11 12-7 8-9 9-7 8-30 30-8 7-8 8-11 9-12 11-11 9-13 11-12 9-14 11-18 13-20 14-23 15-19 12-26 15-16 9-42 22-33 15-28 12-29 11-34 12-33 10-34 9-29 7-47 9-40 6-49 5-32 2-24 1h-48l-41-2-37-3-33-4-39-6-31-6-43-10-36-10-35-11-31-11-28-11-11-5v-2h-2v-2h-3l-3-3-5-2v-2l-3 1-7-2-4-4-3-1v-2l-5-1-3-1v-2l-6-2-14-7-11-7-6-5-2-3-5-2-2-1v-2l-5 1-8-6-1-3h5l6 3v1l17 5v2l9-1 12 5v2h6l9 4 6 2 4-1 3 1 3-2 9-2 5-3 10-2 1-7-5-1-1-4 5-3 2-5h2l1-2 5 1 1-3h2v-3h-9l-8-8v-5l5-5 5-1h6l2 6h-7l-4 2-1 2 4-1 4 3 5-3v2l3-2-1-9 2-1 5 4 4-2 5-5h3 2l1-3 1-2h2l2-5 4-6h2l1-6 4-2 2-5h2l1-4h3l1-4h3l-1-3 4-1v-2l5-3 7-1 3 2 9-1 4-2h3v-3h-7l-7 5-3-1v-6l2-2v-6l5-4 8-5 5-6 5-5 4-7h2l-1-7 7-1 1-3h3l1-9-5 1v-2l7-3 1-2h-2l-1 2-2-4v-3h3l1-6 7-3 2-5h2l1-3 3-3v-5h3l5-7 3-1-4-2-3-2-1-2-5 1-2-2 1-5v-4l-5-1-4-4v-2l10-4 3-1-11-2v-1h43l26-4 12-3 21-8 16-8 15-9 14-10 13-11 22-22 13-17 11-15 8-13 8-14 12-23 12-28 10-28 10-35 8-36 6-36 4-36 3-47 17-3 31-6 32-9 30-11 29-13 25-13 27-16 24-16 17-12 14-11 10-8 17-14 11-10 8-7 15-14 19-19 7-8 10-10 7-8 6-8 5-5 14-17 11-14 15-20 9-13 22-33 5-5 6-1-1 4-3 2v4h-2l-2 8-5 5-3 8h-2v3h-2l-1 4h-2l-1 6h-2l-2 5 3-3 3-2 3 1 2-6 4-4 7-12h2l1-4 2-4h2l1-4 6-11 4-4 4-11h4l-1 5h-2l-3 9h-2l-2 10-4 1 1 4-9 18h-2v3l4-4 4-7 2 2-6 15-5 3h-2l-1 9h-2l-1 7h-2v9l-5 2 1 2h-3l-1 4h-2l-1 5-3 8h-2l-1 6-9 6-3 6-3 3 3-1 2-4h3v-4l6-3 2-3 3-6h2l1-3 4-4 4-5 2-1-1-3 2-1 2-7 3-3 5-1 5-10 5-3 1-3h3l1-5h2l2-4 4-1 2-6 5-5h3l1-5 3-3 3-1v-2l5-5 1-2h4l1-3 6-5v-2l3-1 2 1-1-3h3l2-4 4-2 1-4 4-2 1 2 7 1 2 6 5-4 1-2h2l2-5 3 1 1-4h2v-2h2l1-3 1-1h2v-2h2v-2h2v-2l4-2v-2h2v-2h2v-2l4-2v-2h2v-2h2l-1 5-4 4-3 1-1 2h3v-2h2v-2h3l1-4h3l1-4-2-4h2v-2l3 1v2h-2l1 2 2-3h2l2-2 2 2-1-3 2-1 2-4 1 3 4-1 3-3 1-3 5-4 1-4 4-1 2-4 3-4h2l2-4 2-6v-3l1-4 3 1-1 2h3l1-7 6-1 1-2 4 1v-3h4l1-3h3l1-5 4-1 5-5h2v-2l4-2 2-4 4-3 4-4v-2l2-1 1-3 3-1 1-3 3-1 1-8h-2v2l-4 2v-2h-2v-3l5-1 2-8v-3l-2-1 1-6 4-6h2l1-5 9-10 2 1-1 4h2l-2 4h-2l1 2 4 1v2h4v-2l6-3v2h2l1 10v2l-1 2-2-1 1 3v2l1 2 2-2v-9-2l-1-1 1-7 4-4 1 5-1 9 3 3 1-8 4-4h2l1-4h2v-2h3l2-2h3l-2-4h2l2-4 3-3 4-2 2-5-3-1 2-11 4-6 4 1 2-4 3-3 2-7 4 1 2-5 1-6 4-4 1-4 4-2 1-3 4-3h4l1-10 2-5h2v-2h2l1-3h7l2-2 6 5-1 3h-6v7l-2 5 7-7 4 1 2 6-1 2h3l-1-10-2-3 2-3h2v-5h-4l-1-7 4-2 9-2-2-2 3-1 3-10-2-5-2-4h8v-2l7-2v-7h2v-2l5-1h3l1-5 5 4z"
      fill="#D86C6B"
    />
    <path
      transform="translate(1377,384)"
      d="m0 0h16l26 2 19 3 25 7 19 8 19 10 17 12 13 11 5 4 9 11 8 10 9 13 9 16 8 17 7 20 4 14 5 23 4 33v50l-3 30-6 36-7 31-9 31-13 38-10 24-13 29-17 34-14 24-8 14-12 19-13 19-9 13-14 19-13 16-11 14-8 10h-2l-2 4-9 10-7 8-10 10-7 8-23 23-8 7-13 12-11 9-13 11-16 12-13 10-24 16-19 12-23 13-25 13-28 12-31 11-31 8-26 5-17 2v18l-3 39-4 33-7 39-8 34-10 33-12 32-12 26-12 23-12 19-11 15-11 14-9 10-20 20-17 13-19 12-16 8-15 6-11 4-27 5-8 1h-33l-25-4-17-4-24-9-17-8-22-13-14-10-14-11-10-9-12-11-14-14-7-8-11-13-13-17-12-17-13-20-9-15-14-25-14-28-12-28-10-26-8-22-8-26-11-41-8-37-7-43-4-34-3-38-1-27v-33l2-36 3-32 5-35 8-40 8-30 8-26 9-24 9-21 8-17 13-23 11-17 12-16 9-11 12-13 10-10 11-9 14-11 15-9 17-9 25-9 16-4 27-4h16l24 3 23 5 21 7 22 10 21 12 10 7 12 9 16 13 12 11 16 16 4 3 1-6 3-4 8-16 8-13 6-11 8-13 11-17 13-19 13-18 10-13 14-18 22-26 12-13 7-8 13-13 7-8 8-7 14-14 8-7 14-12 13-11 16-12 13-10 16-11 15-10 25-15 24-13 29-14 28-11 28-9 26-6 24-4z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1344,97)"
      d="m0 0 9 1 8 2h7l16 4 13 4 33 11 7 3 12 2v2l9 2 5 3 4 1 3 3h3l3 3v2l4 2 7 4 7 2 4 2 9 3 7 2 24 14 26 16 18 12 16 11 18 13 21 16 10 8 14 11 15 13 14 12 13 12 5 4v2l4 2 40 40 7 8 14 15 9 11 10 11 11 14 13 16 15 20 10 14 14 20 12 19 14 22 16 28 10 18 15 29 10 21v2h-3l-1 5 2 3-1 4-2-2v-3l-4-2-5-12-1-6h-3l2 5-1 3-5-4v5l-3 2-2-2h-4v2h-2l1 5-3 3-5 1v2h-8l4 5 1 5-4 11-1 2-12 3v7l4-1 1 4-1 2h-2l-1 4 2 2v10h-3l-1-6-1-2-4 1-5 6-2-1 2-6v-6l3-1h4l-1-3-5-3v2h-8l-1 2h-2v2h-2v5h-2l1 4-2 6-5 2-3 1-1 4-4 2-1 4-2 3h-2v6l-3 5-3 1-3 6-5 6-5 1-3 9-1 6 2 1-1 5-2 3-4 1-5 6 1 3-4 2-2 2v-2h-2l-1 6-5 2-2 2-1 6-1 2-2-1-2-4 1-10-1-1-3 5v5l2 3-1 5v5l-3 2-3-5 1-3 2-1v-4l-1-6 1-2h-4l-4 1v2h-4l-2-2-3-1v-2l4-4h-2l-1-4-9 10-1 4h-2l-2 5-3 7 3 1 1 3h-2l-2 8-5 1v3h4 2v-2h2l1 4-2 5h-3l-1 4h-3l-1 4h-2l1 4-4 2-1 2-4 2-3 4-1 2-2-1-1 4-5 3-4 3-2 1v2h-3l-1 4h-3l-1 3-4-1-5 3-2-1v8h-5l1-3-2-1-1 5v3l-1 5-5 5-5 7-4 3-3 6h-3l-1 4h-2l-1 3-4 1-1-3-1 5-1 1-1 2-2-1-2 1-2-1-2 4-1-3h2l-3-3-1 3 2 4-2 3h-3l-1 4h-3v2h-2v2h-3l1-3h3l2-4h2l1-5h-2v2h-2l-1 4h-3v2h-2v2h-2l-1 4h-3v2h-2v2h-2l-1 5-2-1-1 2h-2l-1 4h-2v2l-4 2-1 2h-2l-2 4-5 3-1-6-9-1v-2l-3 2-1 3-5 4-3 3v2h-5l1 3-4 2-2 3-2 2h-4l-2 5-1 2h-3l1 3-5 2-1 3h-2v3l-6 2-2 6-8 8h-2l-1 5h-3l-1 4-5 3-4 9-2 2h-6l-1 7-4 8h-2l-1 5-4 1-3 5-4 4-1 4-3 3-4 2-1 3h-3l-2 5h-3l1-3 3-3 2-4 6-4 3-5 1-2h2l1-8h2l1-5h2l1-4 2-1-1-2 5-2v-6l1-2h2l1-7h2l-1-6h2v-3l4-3h3l2-8 3-8-7 10-4 1 2-4h2l2-6 6-12v-4h2l1-3 3-8h2l1-6 4-4v-4h-2l-5 12-3 1-2 5-6 12h-2l-2 5-1 3h-2l-2 5-7 11-4 8-1-2-3 1-4 4-2-1 3-5h2l2-8h2v-2h2v-3l2-1 3-8 3-5 2-4 2-1v-2h2l-1-4 4-2 1-4-4 2-4 1 2-5 15-26 12-22 15-30 13-30 9-23 13-38 10-37 7-35 4-28 2-22v-50l-4-33-6-28-8-24-8-18-9-17-9-13-9-12-9-10-5-5-9-8-18-13-14-8-19-9-21-7-17-4-23-3-17-1h-16l-21 2-24 4-26 6-36 12-24 10-29 14-24 13-21 13-15 10-20 14-18 14-14 11-15 13-11 10-8 7-14 14-7 6-7 8-13 13-7 8-10 11-9 11-11 13-12 16-14 18-13 19-9 13-11 17-12 20-12 21h-2l-1-4h-6l-1 2-4 2-8-2-1-2-7-4-2-4-4-1-8-5-4-4v-3l-4-2v-2l-4-1v-2l-5-2-7-4v-2l-4-1-15-10-24-12-5-1-3-1v-2l-9-2-13-5-16-5-11-1-10-3-9-1-17-1-10-1-6-1-7 1h-7l-7 3-10-1 2-4 5-2h7l10-4 7-1 6-2-7 1-12 1-3-3 5-2h3l3-3 7-2 3-5 5 2 5 1 2-3-5-1 1-5 5 1 6 3 2-4 2-2h5l1-3 8 2 2-1 2-3 5 1 5-2 7-4 10-5 6-1 3-3 3-1v-5l7-1 2-4 7 1v-3h2v-2l5-4 5-5 4-5h5l1-5 2-3h5v-3l3-1 2-3 2 2h3l-2-6 4-4h2v2h2l1-2 3 2v-2l4-2v-2l5-1v-3l2-1 1-3 4-3 2-3h2v-2l5-1v-3l6-5h2v-3l4-1 2-4 6-5 3-1 1-4 5-1 1-4 5-2v-2h2v-2h2v-2l4-2 5-5h2l2-4h2v-2h2v-2l4-3 2-2h3v-2h2v-2h3l1-4h2v-2h2v-2h3l1-4h2v-2h2v-2h3l1-4h3l2-4 8-8 4-3h2v-2h2v-2h2l2-4h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2l1-2 5-5 5-4h2v-2h2v-2h2v-2h2v-2h3l1-4h2v-2h2v-2h3l3-6h2l1-3 4-3h2l2-4 6-5h2v-3l6-5h2l2-4 9-9 4-5 10-8 20-20h2l2-4 10-9 5-4h2v-2l5-3 8-5h5l1-4 5-1 6-4h2v-3l4-1v-2h2v-2h2v-2h2v-2h2l2-5 5-6h2l2-5 3-4-8 4h-2l-2 4-5 5h-2v2h-2l2-5 3-2 5-11 8-9 2-5h2v-2l5-1 2-5 7-2v-4l4-5 4-1 1-2h2l2-4 2-2 6-2 2-6 6-2-1-2 3-2-1-2 5-4 6-3v-6l6-5 2-2 4-1 3-3 7-3 3-2 7-1 1-3 2 1v4l4-1v-2h2v-2h9l12-2 15-1 8-5 1-6 4-3 7-3 1-2 5-2 7 1 8 5 4-1v-6l1-2h2v-3l-9-3-5-8-7-6z"
      fill="#DD944D"
    />
    <path
      transform="translate(435,937)"
      d="m0 0 3 6 2 21 2 2v5l-2 3 5 2-2 1v6l5 1-1 23 2 7 2 4 3-2v14l-2 25-1 23v33l2 42 4 42 5 35 7 38 9 38 10 35 11 33 10 26 11 26 14 29 11 21 13 22 15 23 12 17 11 14 9 11 10 11 7 8 15 15 8 7 13 11 18 13 20 12 16 8 21 9 16 5 27 5 1 2 10 1-3 3-5 1-4 2h-3l5 6 4 1v2l2 1-2 2 1 5 7-1v3l5 2 2 3h-4l-2 4-3 4h-2l-1 6-6 5-2 5-6 2-2 6h-3l3 5 4-2-2 5-8 2 5 1-1 9h-3l-1 4h-7l1 7-2 1-5 9-5 4-6 7-9 5-1 3-1 5-1 1v6l5-2 5-3 6 1v3l-7 3-9 1-5-2-6 2-4 1v2l-3 2v2h-3l-1 4-3 1-1 3-2 1-2 5-4 1-1 6h-2l-2 4-4 7h-2l-1 3-1 2h-2l-1 2-3-1-6 7-8-4v6 4l-5 1-4 2v-2l-7-1 1-3 4-2h6v-2l-2-1 1-2-6 1-5 1-4 4 1 4 4 6v2l11 1-1 5-2 2-5-1-4 4-2 4-3 1 1 4h5l-2 8-12 4-6 3-7 2-5 1v-2l-2 2-4-1-12-4-7-2v-2l-8-2-5-2-5 1-3-1v-2l-11-2-7-2-1-2-6-2h-2v2l4 2 5 3h4v2l7 2 2 1v3l3 1 3 3 15 9 16 8v2l8 2v2l5 1 4 4 8 1v2l6 1 2 1v3h3v2h2l-1 2-37-17-19-9-38-20-17-10-19-11-17-11-25-16-16-12-16-11-28-22-10-8-14-12-11-9-12-11-8-7-15-15-8-7-19-19-7-8-12-12-9-11-12-13-9-11-14-17-10-13-16-21-11-16-14-20-11-18-11-17-15-26-10-18-15-29-3-6v-2h2l-2-5-3-4-1-4-3-5-2-4-4-11-4-14-5-12-2-11-2-1 1-2h-2l-1-5-4-9-1-4-2-9-2-5-5-21-5-19-3-15-1-11 2-3 3 1-2-12 1-2 3 1 3 2v5h2v2h2l1 3 5 2 3 2 3-1 1-3h4v2l4 2h3l2-8h2l1-6-2-1 1-3 2-1-2-4 5-1v-2l4-2 1-5 3-1 1-2h6l1-2 3 1-1 2h2l2-2 3 2v-2h2l1-4h2v-2l4-2v-2h2v-2l4-2-1-3h2l-1-3h2v-2h-2v-4l1-6 4-6h2l2-9 2-5 1-2-1-3 3-9 2-5 3-5 2-4 1-1h5l-2 6 3 3 4 2v-2l6-3v2h2l1-3h4v-2h2l2-6 6-8 2-1 3 10 2 1v-5-3l7 1 1-3v2h2l-1-4 4-6 1 4v3h2l1-5 1-3h4v2h2v-11l2-5h4l1-3h3l2-6 3-2v-4l2-3h4l-1-7h2l1-9h6l-1-8v-3h2l1-8 2-3 3 9 1 7v8l3-2v-5l1-1 1-11 1-13 2-5 2-6 5 3v2h4l2-3 1 5 2-1 2 4 2 14 4 11 2 6 3-1 1-6v-5l5-6h2l2-5 4-7 3-5h2l1-4 2-1 1-8 4-2 4-5 4-6 3-1 1-2h2l1-6 1-2h3l1-5 4-2 1-3h2v-8l5 4v-2h2l-1-3h2l-1-6h2l1-5 4-2v-2h2v-5l5-4 4-2 3-5 3-4 3-1-1-2v-6h2v-2l3-2 7-1 1-3h-2l1-4h3l1-2h4l-2-5 5-5 1-4 1-5z"
      fill="#DD944D"
    />
    <path
      transform="translate(1e3 28)"
      d="m0 0h14l3 1 46 1-2 2-13 1h-23l-30 1-2-1-1 2v-2l-8 2h-12l-12 1-14 3-8 2h-4v3l-2 1 1 4 8 1 2 3 5-2h3l2 2h7l5 2 8 2 3 2-1 10 2 3 5 2-1 2h-2v2h-2l-1 2-1-5-7 2-2 2v4h3v4h2l2-6 3 1-4 6-1 4-6 3h-2l-1 4-5 4h-2v2h-2l1 3-4 5-4 4v3h-3v2l-2 1v4l-4-1-1 7 7 1v4l-7-2 1 6 1 4v7l-1 2h-3v2h-2l-2 7h-2v5l3 1-2 1v3l-4 2 2 7-7 2-2-1v8l-6 3h-2l-2 6-2 3-4 1-8 8-4 2-1 5-4 1-7 3-3 4-1 2-2-1v-3l-6 1v2h-6l-4-1-2 4-5 2-4 2-1 2-6 1-5 6-5 2 2-8-1-4-5 3-5 4-5 3h-2l-2 4-8 7h-2l-2 4-5 4h-2v2l-4 3h-2l-2 4h-2l-2 5h-2l-2 4-5 4-1 2h-2l-2 4-6 4-3 1v2h-5l-7 8v4h-5l1 4-3 1v2l2 1 1 6-4 4-1 2h-2l-2 6-1 2h-2l-1 4h-2v3h3v4l-6 5-5 4h-2l-2 4-3 3 7 2 1 3-6 5-4 1-2 2-6 4-6 5h-2v2l-6 3-11 10-7 3-2 3-5 3-9 9-8 1-6 7-11 9-4 2-2 4h-2l-2 4-4 4h-3v2l-6 5-4 4h-2l-2 4-2 1-1 4-3-1 1 3-3 2-2-1 1 3-5 5-5 2-5 6-7 6-5 5-7 6-5 5-3 1-2 4h-3l-2 4-8 8-3 4h-3l-1 3h-3v2h-2v2l-4 3h-3v2h-2v2h-2v2h-2v2l-5 3-4 4h-2v2h-2v2l-5 4-4 4-5 4-4 2-3 3-5 1 1 3-7 2-1 3-6 5-5 5-4 2-2 4-6 5-4 1 1 2-6-1-15 15-6 8h-2l-2 5h-2l-2 5h-2l-1 3-6 5-5 6-4 1-2 4-5 4h-2l-2 4-8 9h2l-2 8-4 2-2 4h-2l1-10h2l-2-8 2-4-2-2-1-8-4 1 2-5-3 1-5 6h-2l-2 4-7 9h-2l-2 4-6 13-5 10-4 10-4 5-4 9-4 7-1 1v5l2 1-2 9-6 9-7 13-3 4h-2v2h-2l-1 4-3 5-2 3h-2v2h-2l-2 7-2 3 4-1 2 2-2 5-3 5 1 6-3 5-3 2-3 5h-2l-1 3-2 1-2 4h-3v3l-3 1-1 2-5 1v2l-4 1v2l-5 1-1 2h-2l-1 5-3-1-1 6h-2l-4 4-3 5-2 3h-2v2h-2v2h-2v2h-2l-1 2-4-3-2-1 1-3-3-1 1-4h-2v-2h-2v4l-2 2-2 1 1 3h-3l-2 7-4 4h-2l-1 5h-2l-1 4-8 10-6 4-3 1-6 10h-2l-1 5h-2l-1 3-3 1-4 5-4 4-3-1v-2h-7v-3h-6-3-2l-2 8-3 1-1 4-7 4-8 1-2-4-4-1-2 5-3 9 2 4v3l-4 2h-5v-2l-7 1-6 5h-2v-2h-2l-1-8-2-4-8-2h-2l-1 2-1-1-2 4-1 5-1 3-2 1-2 25-3 11-2 6-3-2v-27l3-49 4-39 7-47 8-41 10-42 12-42 12-36 11-30 14-34 9-20 12-25 12-24 12-22 14-24 12-20 24-36 12-17 14-19 22-28 12-14 9-11 12-13 7-8 7-7 7-8 36-36 8-7 7-7 11-9 12-11 11-9 15-12 14-11 20-15 20-14 13-9 25-16 21-13 25-14 10-6 54-27 32-14 30-12 36-13 41-13 37-10 35-8 49-9 44-6 31-3 31-2z"
      fill="#EBC42F"
    />
    <path
      transform="translate(2016,1022)"
      d="m0 0 2 1v12l1 4h2v5 4l-2 2 2 2v4 10 2l1 1v28l-4 44-5 36-6 37-9 42-8 32-13 44-14 41-13 33-14 32-14 30-10 19-8 16-16 28-10 17-11 17-14 22-13 18-12 17-10 13-12 15-11 14-9 10-9 11-11 12-7 8-9 9-7 8-30 30-8 7-8 8-11 9-12 11-11 9-13 11-12 9-14 11-18 13-20 14-23 15-19 12-26 15-16 9-42 22-33 15-28 12-29 11-34 12-33 10-34 9-29 7-47 9-40 6-49 5-32 2-24 1h-48l-25-1-7-1-4-6-4 1-2-1 1-2 3-1 2-2 4 1 21 1 27-1 16-2 12-1h2l7-3 3-4h2l1-3 5-1 5-3h3v2h8l12-5 6-3h3v6h6l-1-3h2l1-4 8-1h1l6-1 7-1 4 1 1-7 2-2h3v-2l3-3 6-3 2-5-2-3 1-7 6-1-1-3 6-2 1-3 7-2 2-1v-3l5-2 2-3 5-1 2-4 5-4 3 1v-2h2v-2l-2-1h2l2-4h2l2-4 4-2v-7l5-1 2-2h-4l-1-6 1-2 4-1v-3l1-4h-2v-2h2v-2l-2-1 3-5v-4l3-5v-2h2v2l3-1 1 1 6-5h2v-2h2l2-4h2v2h2l1-2 2 1 1-3 1 1 2-5 1 2h2v-2l4-4h2v-2h2v-2l4-2 2-2 5-2 5-6 6-5h2v-3l7-5 3-4h2l2-4 4-4h2v-3l5-3h2l2-5 4-1 1-4 4-2 1-2h2v-2h2v-2l4-1v-3l4-1v-3l4-3 4-2v-2l7-4 4-3h2v-2l4-4h3l1-4h2l2-2 3 1v-2l5-4h2l2-4h2v-2h2v2h2v-2h2v-2h2v-2l8-7 4-1 8-7 4-1 8-7h2v-2l4-4 4 1v-2l6-5h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2l5-2v-2l4-1 2-4h2v-2l7-6h2l2-4h2v-2h2v-2h2v-2l5-1 1-5h2l1-2 4-2 4-5 5-5 2 1 1-4h3l1-4h3l1-4h3l1-4h3l1-4h3v-2l7-6 1-2h3l1-5 4-1 1-3 3-3h3v-2h2l1-2 4-1 2-7h3v-2l3 1 2-7 6 1 1-4h3l2-4h2l2-4h2l2-4h6v-2l-3 1 1-3h6v-3l4-1v-3l4-1-1-2-3 2 2-4h2l2-4h2l2-4 14-14 2-4 7-6v-2l4-2v-2h2v-3l5-5 6-7 2-4h2v-3l4-1 1-4 4-6h2v-2h2v-2h2l2-5 3-4h2l2-4 7-11 3-7 5-5 8-12 5-5 4-9 1-3h2l1-5h2l2-4 2-5 8-12 1-4 3-8h2l2-4h2l-2 9-3 7h-2l-3 15 2-6 4-5v-2h3l2-4 6-8 8-22 3-6-1-3 3-1 12-25 2-11 8-11 4-8h3l2-1v-3l5-5 4-2 1-2 2 1 1-5h2v-3l4-2 2-3h2l2-2 1 4v2l4-11 2-4h4l-3 12-2 4v4l-2 3-1 4 2 1v3h5v-2h2l2-4 7-2 1-7 2-3 2-1 2-3 1 1 1-5 5-1 1-5h2v-2h2v-2h2v-2h2v-2h2v-2l4-2v-2h2v-2h2l1-4 2-2h3l5 5v-2h2v-2h2v-2l5-1v-2h2v-2h2v-2l4-1-2-4 5-1 4-5 3-2v-2h2v-2l5-1v-2h2l2-4h2l2-4 3-1 2-6h2v-2l-2-1 2-3h2l-1-9 7-2v-2l-2 1-3-2v-5h2l1-3 4-1v2l3-1 1-3h2v-3l5-5-1-3-2-2 3-1 3-4h6v-2l4-2 2 2 2-4h4l-2-1v-6l3-5h2l2-4 4-1 1-5 5-9h3l2-8-2-4h2v-3h2l2-6 1-1-1-7 6-7h2l3-11-1-5 6-3h2l3 3v-6l-1-3z"
      fill="#D05975"
    />
    <path
      transform="translate(1914,596)"
      d="m0 0h3l4 12 4 7 2 1 2 4-1-4-1-7 2-1 1-2v3h3l15 34 13 33 12 34 5 15-1 4-4-1-2-3-1-7-3-4-3-9-5-13-7-13-1-4h-1l4 12-1 3-3-2 1 11-2 7-1 3-1 1-4 2v6l-3 3h-4v2h-2v2h-2l-1 2-3-2h-3l-2 6-6 2h-2l1 3h6v2h2v2l2 1-2 2-5 2-5 1h-3l-2 7-4-2-4-4-8-1-2 5-4 1h-4v6l-2 3-3-1v-6h2v-2h-2l-1-2-7 1-4 8-3 3 1 2h-2l-1 4h-2l-1 4h-4l-1 5-3 1-2 6-3-1-1 2-4 4-1 8h-2l-1 3h-2l-2 8-4 1v2h2v2h-2l-1 4-1 2h-2l-2 4-5 1v2l-2 2-2 4h4l-1-3 5-1-1 4-6 9v2h-3l-1 4-5 1-1-8-4-4-4 1-1 5-9 8h-2v2h-2l-1 2-2 3-2 4-6 4h-2l-1 3-4-1v-2h-2l2 5-3-1-1 2 1 4-4 2v2h-2l-2 4h-2l-1 2h-3v4h-4l-1 5-3-1v2h-2v2l-4 2v2h-2l-1 2-3 1v2l-2 1v2h-2l-1 2-5 5-3 1-2 4-4 2v2h-2v2h-2v2l-3-1 1-5 1-1-3-3-2 6 1 2h-4v2l-2-1-1 1v2h-2v2l-4 2v2h-4l-1 1-4 1-2 4-3 2-1 2-2-1-1 5-4 1v3h-2l-2 4 5-4 1-2 4 1v2l-2 2-2 1-2 4-3 3-1 3h-2v2l-5 4-1 2h-2l-2 10-4 5-6 5-7 8h-2l-1 3h-2l-1 4-5 4 1 2-7 9h2l1-2 1 3 2 1v-2l5-4v2l3 1-2 4-4 1v3l-4 1-2 4h-2v3l-4 1v3l-4 1-1 5h-2v2h-2v2h-2v2h-2l-1 3-5 6-4 2v2h-2l-1 4-4 4h-3l-1 4h-3l-1 4-6 5-6 7-7 6-1 2h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4h-2v3l-6 5h-2l-2 4-6 7-4 4h-2v2h-2v2l-4 4h-2l-2 4-7 6-1 2h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4-4 4h-2l-2 4h-2l-2 4-4 2v2l-4 4h-2v2l-5 4-1 2h-2l-2 4-4 2v2l-8 7-4 2-2 4-8 8h-2l-2 4-4 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4-3 3h-2l-2 4-5 2-1 2-2-2-2 2-1-3-1 5-3 1v-2h-2l1-4v-3l-3 2-6-1-1 3-3 1v2h-2v2h-2l-1 3-3 1-1 3h-2l-1 3-5 4-7 4-2 4-5 2-1 4-4 1-1 4-3 2-5 5h-3v2l-4 4-1 2h-3v2h-2v2l-5 1-2 5-3 3h-3v2h-2l-2 4h-2l-2 5-4 1v2l-4 4h-2l-2 5-4 1v2h-2v2h-2l-1 3-4 3h-2l-2 4h-2v2h-2v2l-4 4-1 5-2-1-3 9-7 6-6 10h-2l-1 4-7 6-5 5v3l-1 2h-2l-1 7h-2v3h-2l-2 4h5l-1 4h-2v2h-2l-4-4 1 5v4l-3 1 1 3h-2l-1 3-1-1-1 2h-2l-1 5h-2l-3 6h-2v2l-3 1-3 7-6 2-1 6-4 2v2h-2l-2 4-3 3-2 5-4 1-2 6-4 2-2 5-6 5-4 8-6 3-3 6-2 3 1 2h-4l-5 5 1 3h-2v3l-4 1-1 4-2 2 1 2h-2l-2 2-2-1-2 9-7 6-5 6-7 6v2h-2l-2 4-4 2-4 4v2h-2l-1 5-3-1-1 2-4 5-1 2-4 4-1 2h-2l-1 2-3 4h-2l-2 4h-2l-2 4h-2l-2 4h-2l-2 4-4 2-1 2-3 1-3 6-5 2-2 5h-2l-4 2h-2l-1 2-3 1-1 4h-3l-2-1-2 9-1-2-1 3h-2l-1 3-5-1-1 5-1 1-1 2-5-1-1 4-3 1-2 4-4 3-4 1h2v2l-4 1v3l-7 2-4 5 1 2-6 1v-3h-2l-1 3h-2v5l-4 5-3-1-3 1-2-1v2l-3 2h-3l-2 5-1 2-10 5h-2v2h-2l-1 2-4 1-1 3-3 1-1-7h-3l-1 8-4-1-5-1v4h5 3v4h-9l-3 4 2 4-3 5-7-1-2 4v3l-1 2 4 1v3h2v2l-8 3-3 2h-3v2h-2v2l-8 3 3 2-4 2v3l-7 3-3-6h2l-2-3-7 1-1 4-5 3-1 4-5 3v6l3 1 1-5h5l3 2v2h-2l-1 8-3 1-1 2h-3l-1 2-3-1h-7l-3-4h2v-2l-5 1-1 4-3 3-2 1-1 5-5 3h-2l-1 3-9 4-4 7-5 2-3 2-3 1-2 6h3v3h-4v3l4 3-1 4-2 7 5 4-2 7-4 1-2 4-5-1-6 2-1 4h-5l-2-4-3-1 1 4-1 2 2 1-2 3-7-2-6-2v2l-9 2-2-2h-7l-13-2-4 2-21-6v2l-4 1 1 3h-5l-3-3h-7l-4-2v-2l-3 1-7-2-4-4-3-1v-2l-5-1-3-1v-2l-6-2-14-7-11-7-6-5-2-3-5-2-2-1v-2l-5 1-8-6-1-3h5l6 3v1l17 5v2l9-1 12 5v2h6l9 4 6 2 4-1 3 1 3-2 9-2 5-3 10-2 1-7-5-1-1-4 5-3 2-5h2l1-2 5 1 1-3h2v-3h-9l-8-8v-5l5-5 5-1h6l2 6h-7l-4 2-1 2 4-1 4 3 5-3v2l3-2-1-9 2-1 5 4 4-2 5-5h3 2l1-3 1-2h2l2-5 4-6h2l1-6 4-2 2-5h2l1-4h3l1-4h3l-1-3 4-1v-2l5-3 7-1 3 2 9-1 4-2h3v-3h-7l-7 5-3-1v-6l2-2v-6l5-4 8-5 5-6 5-5 4-7h2l-1-7 7-1 1-3h3l1-9-5 1v-2l7-3 1-2h-2l-1 2-2-4v-3h3l1-6 7-3 2-5h2l1-3 3-3v-5h3l5-7 3-1-4-2-3-2-1-2-5 1-2-2 1-5v-4l-5-1-4-4v-2l10-4 3-1-11-2v-1h43l26-4 12-3 21-8 16-8 15-9 14-10 13-11 22-22 13-17 11-15 8-13 8-14 12-23 12-28 10-28 10-35 8-36 6-36 4-36 3-47 17-3 31-6 32-9 30-11 29-13 25-13 27-16 24-16 17-12 14-11 10-8 17-14 11-10 8-7 15-14 19-19 7-8 10-10 7-8 6-8 5-5 14-17 11-14 15-20 9-13 22-33 5-5 6-1-1 4-3 2v4h-2l-2 8-5 5-3 8h-2v3h-2l-1 4h-2l-1 6h-2l-2 5 3-3 3-2 3 1 2-6 4-4 7-12h2l1-4 2-4h2l1-4 6-11 4-4 4-11h4l-1 5h-2l-3 9h-2l-2 10-4 1 1 4-9 18h-2v3l4-4 4-7 2 2-6 15-5 3h-2l-1 9h-2l-1 7h-2v9l-5 2 1 2h-3l-1 4h-2l-1 5-3 8h-2l-1 6-9 6-3 6-3 3 3-1 2-4h3v-4l6-3 2-3 3-6h2l1-3 4-4 4-5 2-1-1-3 2-1 2-7 3-3 5-1 5-10 5-3 1-3h3l1-5h2l2-4 4-1 2-6 5-5h3l1-5 3-3 3-1v-2l5-5 1-2h4l1-3 6-5v-2l3-1 2 1-1-3h3l2-4 4-2 1-4 4-2 1 2 7 1 2 6 5-4 1-2h2l2-5 3 1 1-4h2v-2h2l1-3 1-1h2v-2h2v-2h2v-2l4-2v-2h2v-2h2v-2l4-2v-2h2v-2h2l-1 5-4 4-3 1-1 2h3v-2h2v-2h3l1-4h3l1-4-2-4h2v-2l3 1v2h-2l1 2 2-3h2l2-2 2 2-1-3 2-1 2-4 1 3 4-1 3-3 1-3 5-4 1-4 4-1 2-4 3-4h2l2-4 2-6v-3l1-4 3 1-1 2h3l1-7 6-1 1-2 4 1v-3h4l1-3h3l1-5 4-1 5-5h2v-2l4-2 2-4 4-3 4-4v-2l2-1 1-3 3-1 1-3 3-1 1-8h-2v2l-4 2v-2h-2v-3l5-1 2-8v-3l-2-1 1-6 4-6h2l1-5 9-10 2 1-1 4h2l-2 4h-2l1 2 4 1v2h4v-2l6-3v2h2l1 10v2l-1 2-2-1 1 3v2l1 2 2-2v-9-2l-1-1 1-7 4-4 1 5-1 9 3 3 1-8 4-4h2l1-4h2v-2h3l2-2h3l-2-4h2l2-4 3-3 4-2 2-5-3-1 2-11 4-6 4 1 2-4 3-3 2-7 4 1 2-5 1-6 4-4 1-4 4-2 1-3 4-3h4l1-10 2-5h2v-2h2l1-3h7l2-2 6 5-1 3h-6v7l-2 5 7-7 4 1 2 6-1 2h3l-1-10-2-3 2-3h2v-5h-4l-1-7 4-2 9-2-2-2 3-1 3-10-2-5-2-4h8v-2l7-2v-7h2v-2l5-1h3l1-5 5 4z"
      fill="#DA7962"
    />
    <path
      transform="translate(736,719)"
      d="m0 0 18 4 20 7 22 11 17 11 16 12 10 9 8 7 22 22 9 11 8 10 10 13 11 16 14 22 10 18 14 27 11 24 15 38 11 33 10 37 7 29 7 38 6 45 3 34 1 26v58l-3 42-5 37-6 31-8 32-12 37-12 29-8 16-11 20-14 21-11 14-9 10-15 15-17 13-12 7h-3l4-73 6-107v-72l-3-39-4-32-7-38-7-30-8-29-12-36-14-35-16-36-12-30-14-43-10-40-7-38-14-95-14-97z"
      fill="#DD944D"
    />
    <path
      transform="translate(1519,493)"
      d="m0 0 4 2 10 18 7 16 6 18 5 21 3 20 1 11v49l-3 29-5 30-7 29-7 24-9 27-12 30-11 25-11 23-12 22-14 25-22 34-13 19-14 19-13 16-18 22-12 13-11 12-14 15-15 15-8 7-14 13-11 9-13 11-17 13-18 13-21 14-15 9-16 9-17 9-27 12-24 9-24 7-24 5-18 3h-4l-5-62v-5l10-10 8-7 12-11 8-7 10-9 8-7 12-11 10-9 8-8 8-7 9-9 7-8 9-9 8-10 9-10 11-14 12-15 12-17 20-30 12-20 10-18 14-27 13-28 13-33 11-28 13-29 17-34 13-22 15-24 12-17 10-14 10-13 8-11 6-8 13-17 78-104z"
      fill="#DD944D"
    />
    <path
      transform="translate(595,771)"
      d="m0 0h2l2 8 11 80 11 77 6 35 6 28 10 38 12 36 9 24 26 60 11 29 11 34 12 48 6 34 4 32 3 41v51l-5 93-4 72-1 15-6-2-20-12-17-13-10-8-12-11-15-15-7-8-9-11-12-15-14-20-14-22-10-18-12-23-12-25-12-30-12-34-9-29-10-40-8-41-6-42-4-43-1-20v-58l2-34 5-42 7-38 9-36 12-36 10-24 9-19 13-23 12-18 10-13z"
      fill="#DD944C"
    />
    <path
      transform="translate(1384,428)"
      d="m0 0 1 2-10 14-81 108-14 19-13 18-15 23-12 20-13 23-10 19-15 33-13 33-15 37-16 34-15 28-12 20-9 14-8 12-12 17-22 28-9 10-9 11-8 8-7 8-22 22-4 2-9-25-9-24-13-30-14-29-14-26-15-24-16-24-2-4 8-18 13-23 11-20 14-22 11-17 24-34 12-15 10-13 12-14 11-12 7-8 11-12 26-26 8-7 14-13 10-8 13-11 20-15 14-10 15-10 16-10 21-12 23-12 28-12 20-7 23-7 31-6z"
      fill="#DD944C"
    />
    <path
      transform="translate(685,719)"
      d="m0 0h6l1 1 13 93 15 104 6 37 8 37 8 29 8 26 9 25 12 29 18 41 11 29 12 37 11 44 7 39 4 33 2 30 1 24v20l-4 86-2 29-3 59-3 48-1 4-2 1h-39l-12-2v-17l5-88 4-70 1-29v-32l-2-40-3-30-4-28-7-36-7-29-9-31-13-38-10-24-11-25-14-33-8-22-10-32-9-36-7-36-15-103-11-76-4-30 15-8 23-8z"
      fill="#DD944D"
    />
    <path
      transform="translate(1437,435)"
      d="m0 0 11 3 15 6 15 8 10 7-2 5-10 13-13 18-10 13-14 19-10 13-14 19-10 13-14 19-16 21-14 19-10 14-18 27-12 20-16 28-8 16-12 26-13 32-13 33-12 27-8 17-12 22-15 26-22 33-14 19-13 16-9 11-9 10-14 16h-2l-2 4-16 16-8 7-9 9-8 7-11 10-8 7-12 11-5 4h-2l-7-32-5-23v-6l1-2h2l1-3 8-7 12-11 28-28 7-8 9-10 9-11 14-17 12-16 13-19 12-18 8-13 10-17 6-10 20-40 16-38 13-34 12-27 12-25 14-26 12-20 22-33 21-28 8-11 10-13 24-32 8-11 10-13 24-32 14-19z"
      fill="#DD944C"
    />
    <path
      transform="translate(1332,1177)"
      d="m0 0 4 2-4 5h-2l-1 3h-2v4h-3l-1 2-3-1-1 5-1 2-5 1-3 5-5 1-1 2-5 2-2 4-1-1-1 5-5 2h-3l-1 5-7 1v3h-2v2l-4-1v2l-2 1 4 3v2h-5v2l-5 2-1 2-5 1-2 6-4 2 1 4-4 1v2l-3 1-2 1 1 2-6 2-2 5 1 3h-5l-1-1-3 7h-3l-1 5-6 2-3 3-1 2h-2l1 3h-3l-1-1-3 4h-2v2h-4l-1 3h-4l-1 5 4-3 3 1 2-2v2h2v2h-2l-2 5-3 3h-2l-2 4h-5l-2 7-4 2h-3-2v8l-2 3h-2l-1 2-3-1-2 8-4 4-3 4h-2l-1 6h-2v2l-5 1-1 4-2 1-3 3h-2l-1 5-4 1-1 4-3 2h-3l-1 4h-3v2h-4v2h-2v3l-6 4h-3-3l-3-2v2h-2v2h-2v-3l-7 2 1 4-4 4-4-1v2l3 1-1 2-2-1v2l2 1h-2l-1 3-1 2 2 2-4 1-8-3-4 5-4 4-1 2h-2l-2 6-2 1-3-5v-9l2-4 2-7 4-1v-3h-8l-7 7v6l-5 12-1 6-4 6-3 9-1-3-7 15-3 7-2-1 1-8 4-12h2l1-9 3-9 9-39-1-3 7-39 5-43 3-47 17-3 31-6 32-9 30-11 29-13 25-13 27-16 6-4 2 1-1 2h-3v2l2 1-2 4-1 4-3 2-5 2-3 1-1 2-4 4-3 1-1-2-3-1v4l-2 2-3 1 1 3 3-3 5-3 4 1h4l6-1v-2l9-4h2v-2l7-3 3-3 5-1-9 9-5 1-3 1 1 4 4-4 5-1v-2l6-3h2v-2l4-2h4v-2l8-3v2l5-1 1-2h2l-1-3 5-1h3l3-4 8-3 3-3 3-1 5-2v-2z"
      fill="#DC934D"
    />
    <path
      transform="translate(1475,621)"
      d="m0 0 9 1 9 6 5 8 4 18 1 8v32l-4 22-5 17-11 23-10 14-7 5-3 1h-12l-8-4-7-8-2-8 1-8 6-11 7-12 6-16 3-14 1-11v-15l-3-18v-12l3-7 5-6 8-4z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(808,835)"
      d="m0 0h9l14 7 14 11 13 12 9 9 12 17 10 19 7 20 3 14v9l-3 8-6 7-6 3h-14l-8-5-4-5-4-11-6-20-8-16-9-12-8-9-8-7-15-11-5-5-3-4-1-3v-12l6-10 8-5z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(595,771)"
      d="m0 0h2l2 8 11 80v5l-2-4-1-5-2 2v-2h-3l-2-5-4 5h-5l-3-1-3-6v-2l-7-1-4-2-1 9-5 3-6 9-5 9-3 4h-2l-2 6-4 11-2 2-1 4-1 3h-2v2h-2l-3 9-3 6-1 6-3 6-8 28-1 2-1 16-3 8-1 7-3 10-2-1-2-16-2-1-1 17 2 4-2 3h-2l-1 6v36l1 5-3 1-1 8-1 13v39l1 17v23h-1l-2-33v-58l2-34 5-42 7-38 9-36 12-36 10-24 9-19 13-23 12-18 10-13z"
      fill="#E8B235"
    />
    <path
      transform="translate(685,719)"
      d="m0 0h6l1 1 6 43v7l-2-4v-3h-2l-1 5 1 7-1 6h-1l-1-10-2-4-6-1-1-5-2-1v-6l-9-3-5 1-3 4-2 1-1 7 2 1-1 24 1 14-2 4v12l-1 4 2 1v10l1 5v8l3 9 1 15 1 7 1 1 2 14 1 10 2 14v10l3 10v11h-2l-1 2h-3v7h-1l-7-44-17-119-8-55 1-3 19-9 18-6z"
      fill="#EBB149"
    />
    <path
      transform="translate(736,719)"
      d="m0 0 18 4 17 6 1 3h3v2h3v2l-9-1-2-1-2 4-3 3-2 8-3 1-4-1v13l2 5v9l2 14 1 11v3l3 14 1 11h-2l4 12 2 13v6 3l2 4 1 14-1 6v3l1 5v12h-2l-3-10-1-3h-2l-20-139-5-32z"
      fill="#EBB149"
    />
    <path
      transform="translate(794,682)"
      d="m0 0 7 1 14 7 11 6 13 9 5 2 1 2 9 5v2l4 1 4 4v3l4 2v2l5 2 7 4 5 5 5 3v2l9 1 4-3 4-1 3 3 1 4-7 13-3 7-4-2-3-3v-2l-4-2-17-17-11-9-15-12-18-12-16-9-16-8-14-6 4-1 9 3-1-3h2z"
      fill="#EAAF4A"
    />
    <path
      transform="translate(656,816)"
      d="m0 0 1 4h2v3l2 1v10l1 5v8l3 9 1 15 1 7 1 1 2 14 1 10 2 14v10l3 10v11h-2l-1 2h-3v7h-1l-7-44-10-70v-7l2 2 1 3v-8l-1-11z"
      fill="#EBB049"
    />
    <path
      transform="translate(640,747)"
      d="m0 0 4 1 4 9h3l3-1v2h2l3 5 3 2-1 24 1 14-2 4v12l-5 3 1 19-2 3-1-8h-2l-10-69-1-6z"
      fill="#E8B236"
    />
    <path
      transform="translate(686,720)"
      d="m0 0h6l6 43v7l-2-4v-3h-2l-1 5 1 7-1 6h-1l-1-10-2-4-6-1-1-5-2-1v-6l-3-1 3-6 2-8-1-5 1-3v-9z"
      fill="#E8B235"
    />
    <path
      transform="translate(592,774)"
      d="m0 0v3 8l2 1-3 2h2v10l1 3h-2v8l-4 12h-2l-2 4-4 4-4-2-1-2h-3l1-12 4-10v-2h2v-4h2v-4l3-3-2-1-1 3-3-1 7-9z"
      fill="#EBB149"
    />
    <path
      transform="translate(509,963)"
      d="m0 0 3 1v6l-2 5h-3l-2 10-1 17 2 4-2 3h-2l-1 6v36l1 5-3 1-1 8-1 13v39l1 17v23h-1l-2-33v-58l2-34 5-42 4-22h2z"
      fill="#ECB24A"
    />
    <path
      transform="translate(1258,1190)"
      d="m0 0 2 1-1 2h-3v2l2 1-2 4-1 4-3 2-5 2-3 1-1 2-4 4-3 1-1-2h-7l-2 3-9 3h-3l-4 3-2-4 24-13 20-12z"
      fill="#DC8F51"
    />
    <path
      transform="translate(1914,1171)"
      d="m0 0 2 4-1 3-4-1-2 5v3l-3 2v4l1 3-4 1-2-2-3 1-2 5-4 1v-2h-2l-1 4 1 2-2 1-1 3-3 1v2h-2v-2h-2v4l1 3h-2l-1 2-2-1v2l-7 1 1-5 3-4 4-2 2-4 4-1v-3h2v-3l6-2v-5h2v-2l7-1-1-3 3-1v-2h2l2-4z"
      fill="#D05A74"
    />
    <path
      transform="translate(104,1406)"
      d="m0 0 4 4 2 6 4 13 4 11 2 4 3 5 3 7 2 4v2h-3l-11-23-13-30v-2z"
      fill="#EBB44B"
    />
    <path
      transform="translate(450,1037)"
      d="m0 0h1l1 6v12l-1 23-2 3-3-9v-9-3-12l4-8-2-1z"
      fill="#E8B238"
    />
    <path
      transform="translate(1014,28)"
      d="m0 0h39l40 2 12 1v1l-5 1-3 1-1-1-33-1v-2h-46z"
      fill="#E8B63A"
    />
    <path
      transform="translate(1047,1396)"
      d="m0 0 1 2-10 42-3 9-1 5h-2l-2 12h-2l1 6h-2l2 6-2 1-1-3-3 1 3-11 8-24 9-34 3-11z"
      fill="#DA7F5D"
    />
    <path
      transform="translate(1458,127)"
      d="m0 0 5 1 27 14 17 9 3 3-9-2-6-2-2-2-8-2-9-6-2-2-1-3-3 1-3-2v-2h-5v-2l-4-1z"
      fill="#E9B53F"
    />
    <path
      transform="translate(516,964)"
      d="m0 0h2v14l-3 8-1 7-3 10-2-1-1-10 6-25z"
      fill="#EBB149"
    />
    <path
      transform="translate(509,963)"
      d="m0 0 3 1v6l-2 5h-3l-2 10-1 17 2 4-2 3h-2l-2 13h-1v-9l5-35 2-10h2z"
      fill="#ECB24A"
    />
    <path
      transform="translate(925,42)"
      d="m0 0h4l-3 10-12-1v-2l-7 1-3-2v-2h9l4-2z"
      fill="#E8B334"
    />
    <path
      transform="translate(1348,1160)"
      d="m0 0 3 1-1 7-3 1-1 2v-3h-2v5l-3 4h-3l-1 2-3-3 1-6 4-2 1-3 6-3z"
      fill="#DD944D"
    />
    <path
      transform="translate(875,1531)"
      d="m0 0h1v33l-2 23-2 4v-23l2-36z"
      fill="#DB8459"
    />
    <path
      transform="translate(818,832)"
      d="m0 0 11 1v2h2v2l3 1 1 2 3 1v2l3-1 2 7-6-3-7-5-13-5z"
      fill="#EBB04A"
    />
    <path
      transform="translate(1808,1264)"
      d="m0 0h3l-2 5-3 4h-2l-4 10h-2l-2 6h-4l-1-5 2-3h2v-2h2l2-4 1-3 4-1 2-3v-3z"
      fill="#D86C6B"
    />
    <path
      transform="translate(1624,1023)"
      d="m0 0 1 2 3 1-2 4-4 1v3l-6 1-1 2h-2v-3l-3 1v-2l2-1-2-1 2-4 1 2h7v-2z"
      fill="#D97664"
    />
    <path
      transform="translate(1219,1213)"
      d="m0 0h9l-2 4-9 3h-3l-4 3-2-4z"
      fill="#DC8B53"
    />
    <path
      transform="translate(1524,162)"
      d="m0 0 5 2 16 9 12 8-2 1-9-4-1-3-5-1-3-2v-2h-5l-5-4-3-3z"
      fill="#ECB551"
    />
    <path
      transform="translate(762,893)"
      d="m0 0 3 3 2 9 2 5-1 5-3 1-2-9-1-6z"
      fill="#E3A04B"
    />
    <path
      transform="translate(512,970)"
      d="m0 0h1l-1 9-3 11-2-4-1-1v-7l1-3h3l1-4z"
      fill="#E8B334"
    />
    <path
      transform="translate(795,840)"
      d="m0 0 2 2-5 9v15l-2-2-1-4-3-2 1-4 2-1 1-9h2v-2h3z"
      fill="#ECB24A"
    />
    <path
      transform="translate(1589,203)"
      d="m0 0 5 2 15 11 6 4-3 1-3-1v-2l-14-7v-3l-6-2z"
      fill="#EDB757"
    />
    <path
      transform="translate(1669,946)"
      d="m0 0 5 1 2 4h-2v2l-2 1h-3l-3-1-2 4-4 2 1-3 3-1v-3l4-1z"
      fill="#D87167"
    />
    <path
      transform="translate(1119,33)"
      d="m0 0h11l18 2v2l-27-1z"
      fill="#ECC331"
    />
    <path
      transform="translate(616,1936)"
      d="m0 0h6v2l6 1 2 1v3h3v2h2l-1 2-18-8z"
      fill="#DE9856"
    />
    <path
      transform="translate(932,798)"
      d="m0 0 4 1-1 13-3-1-3-4z"
      fill="#E8AA4A"
    />
    <path
      transform="translate(874,1564)"
      d="m0 0h1v13l-2 14h-1v-23z"
      fill="#DA7E5E"
    />
    <path
      transform="translate(130,1471)"
      d="m0 0h3l2 3v5h2v2h2v6h2v2h2v6l-4-5z"
      fill="#EDB756"
    />
    <path
      transform="translate(2019,1112)"
      d="m0 0h1l-1 19-1 10h-1l-1-10 1-6-2-1v-5l2-4h2z"
      fill="#D8706C"
    />
    <path
      transform="translate(513,935)"
      d="m0 0h1v8l-1 2h2l1 4-2 5h-2l-2 3v-9z"
      fill="#E29F4B"
    />
    <path
      transform="translate(1152,36)"
      d="m0 0 19 2 5 1-1 2-18-1z"
      fill="#ECC63D"
    />
    <path
      transform="translate(509,963)"
      d="m0 0 3 1v6l-2 5h-3l-1 3 1-10z"
      fill="#DD944D"
    />
    <path
      transform="translate(1978,728)"
      d="m0 0 2 4 3 9-1 4-4-7h-2l-1-8 3 1z"
      fill="#DC8469"
    />
    <path
      transform="translate(761,728)"
      d="m0 0 9 2 5 2v2h3v2l-9-1-4-3-4-2z"
      fill="#E8B334"
    />
    <path
      transform="translate(1028,1461)"
      d="m0 0h2v5h-2l1 6h-2l2 6-2 1-1-3-3 1 3-11z"
      fill="#DA805C"
    />
    <path
      transform="translate(654,793)"
      d="m0 0 1 4 2 3v6l1 3h-2v2h-2l-1-7-1-8z"
      fill="#ECB24A"
    />
    <path
      transform="translate(1703,919)"
      d="m0 0h6l1 4h-2v2h-2v2h-2v2l-3-1 1-5z"
      fill="#D97664"
    />
    <path
      transform="translate(252,813)"
      d="m0 0 3 1-1 4h-2l-2 4h-3l-3 1 2-5z"
      fill="#E8B333"
    />
    <path
      transform="translate(1212,1911)"
      d="m0 0h2l2 4h-2v7l-5-3-1-4h2v-3z"
      fill="#D76B6B"
    />
    <path
      transform="translate(1258,1190)"
      d="m0 0 2 1-1 2h-3v2l2 1-3 6-4-3v-2l-1-2z"
      fill="#DC924E"
    />
    <path
      transform="translate(1612,1027)"
      d="m0 0 1 2h5v2h-2l2 4h-2l-1 2h-2v-3l-3 1v-2l2-1-2-1z"
      fill="#D86F68"
    />
    <path
      transform="translate(651,759)"
      d="m0 0 1 3v16l-3-3v-12z"
      fill="#ECB24A"
    />
    <path
      transform="translate(773,1621)"
      d="m0 0h13l3 1 14 1v1h-20l-10-2z"
      fill="#DA7D5F"
    />
    <path
      transform="translate(1220,1213)"
      d="m0 0h8l-2 4-9 3h-2l-1-3 9-1-3-1z"
      fill="#DA7963"
    />
    <path
      transform="translate(652,836)"
      d="m0 0 2 2 3 7-3 3h2v8l-2 1-2-14z"
      fill="#ECB24A"
    />
    <path
      transform="translate(147,1503)"
      d="m0 0 5 5 3 5v2h2v6l-3-4-7-12z"
      fill="#EDB654"
    />
    <path
      transform="translate(1249,1196)"
      d="m0 0 4 2 2 4h-3l-3-1-1 2h-3l1-4z"
      fill="#DA7C60"
    />
    <path
      transform="translate(2021,1058)"
      d="m0 0 2 3v17h-1l-1-9-2-3h2l-1-7z"
      fill="#D9716E"
    />
    <path
      transform="translate(674,951)"
      d="m0 0 2 3 1 15-2 1-1-7v-7l-1-4z"
      fill="#ECB24A"
    />
    <path
      transform="translate(1994,786)"
      d="m0 0 2 4 2 8-1 4-2-5-2-2-1-3z"
      fill="#DC8468"
    />
    <path transform="translate(667,934)" d="m0 0 2 1 2 9-4 2z" fill="#E09A4C" />
    <path
      transform="translate(1986,755)"
      d="m0 0 2 4 3 13-3-1-2-9z"
      fill="#DF8E73"
    />
    <path
      transform="translate(947,1513)"
      d="m0 0 2 2-8 13-1-4 1-3 4-4z"
      fill="#DA7963"
    />
    <path
      transform="translate(1565,187)"
      d="m0 0 5 2 7 5-4 1h-2l-3-4-3-1z"
      fill="#EDB756"
    />
    <path
      transform="translate(648,1849)"
      d="m0 0 1 4-7 1-2-2 4-2z"
      fill="#DA7963"
    />
    <path
      transform="translate(1767,768)"
      d="m0 0 5 1v5l-3 2-3-5z"
      fill="#DC924E"
    />
    <path
      transform="translate(1524,162)"
      d="m0 0 5 2 8 5-3 1-4-2-5-3z"
      fill="#ECB24A"
    />
    <path
      transform="translate(518,950)"
      d="m0 0 3 1v2l-1 7-1-2h-2z"
      fill="#ECB24A"
    />
    <path
      transform="translate(929,147)"
      d="m0 0 4 2-1 4h-5v-5z"
      fill="#E8B334"
    />
    <path
      transform="translate(1354,1289)"
      d="m0 0h2l2 6-4 2v-2h-2v-3h2z"
      fill="#D97565"
    />
    <path
      transform="translate(736,1791)"
      d="m0 0 5 1v4h-5l-3-2v-2z"
      fill="#DD944D"
    />
    <path
      transform="translate(664,905)"
      d="m0 0 1 3 1 8-1 3h-2v-13z"
      fill="#E09A4C"
    />
  </svg>
);
export default CCO;
